// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CardNumber: MarkdocTagRegistration = {
  tag: 'card-number',
  description: 'Display a credit card number',
  component: 'CardNumber',
  selfClosing: true,
  children: ['inline'],
  attributes: {
    number: {
      type: String,
      default: '4242424242424242',
      description: 'Credit card number to display expressed as a string',
    },
    copyable: {
      type: Boolean,
      default: true,
      description:
        'If true, a copy icon is shown next to the text which allows user to quickly copy the number to their clipboard.',
    },
  },
};
